var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectsZero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "projects_zero",
    "data-name": "projects zero",
    transform: "translate(-134.472 -131.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(124.831 87.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38724",
    "data-name": "Group 38724",
    transform: "translate(24.644 60.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1235",
    "data-name": "Ellipse 1235",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(-15.003 -16.446)",
    fill: "#a4a9b0",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1154",
    "data-name": "Ellipse 1154",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(-0.003 -1.447)",
    fill: "#a4a9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "invoices",
    d: "M42.908,11.443a7.326,7.326,0,1,0,7.326-7.326A7.335,7.335,0,0,0,42.908,11.443Zm13.536,0a6.21,6.21,0,1,1-6.21-6.21A6.217,6.217,0,0,1,56.444,11.443Zm-6.21-3.768a.558.558,0,0,1,.558.558v.236a1.677,1.677,0,0,1,1.116,1.579.558.558,0,1,1-1.116,0,.558.558,0,0,0-1.116,0v.226a.556.556,0,0,0,.392.533l.666.208a1.667,1.667,0,0,1,1.175,1.6v.226a1.677,1.677,0,0,1-1.326,1.638v.176a.558.558,0,1,1-1.116,0v-.327a1.676,1.676,0,0,1-.907-1.488.558.558,0,1,1,1.116,0,.558.558,0,0,0,1.116,0v-.226a.556.556,0,0,0-.392-.533l-.666-.208a1.667,1.667,0,0,1-1.175-1.6v-.226a1.677,1.677,0,0,1,1.116-1.579V8.233A.558.558,0,0,1,50.234,7.675ZM59.3,22.467v7.117A3.912,3.912,0,0,1,55.4,33.491H33.907A3.912,3.912,0,0,1,30,29.584V2.233A2.235,2.235,0,0,1,32.233,0H50.374a2.235,2.235,0,0,1,2.233,2.233.558.558,0,0,1-1.116,0,1.118,1.118,0,0,0-1.116-1.116H32.233a1.118,1.118,0,0,0-1.116,1.116V29.584a2.794,2.794,0,0,0,2.791,2.791H52.667a3.9,3.9,0,0,1-1.177-2.791V20.862a.558.558,0,0,1,1.116,0v8.722a2.791,2.791,0,1,0,5.582,0V22.467a1.118,1.118,0,0,0-1.116-1.116H54.7a.558.558,0,1,1,0-1.116h2.372A2.235,2.235,0,0,1,59.3,22.467ZM34.884,15a.558.558,0,0,1,.558-.558h4.745a.558.558,0,0,1,0,1.116H35.442A.558.558,0,0,1,34.884,15Zm0-6.28a.558.558,0,0,1,.558-.558h4.745a.558.558,0,0,1,0,1.116H35.442A.558.558,0,0,1,34.884,8.722ZM47.722,21.281a.558.558,0,0,1-.558.558H35.442a.558.558,0,0,1,0-1.116H47.164A.558.558,0,0,1,47.722,21.281Zm0,5.861a.558.558,0,0,1-.558.558H35.442a.558.558,0,0,1,0-1.116H47.164A.558.558,0,0,1,47.722,27.142Z",
    transform: "translate(-9.654 16.808)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsZero);
export default __webpack_public_path__ + "static/media/projects-zero.0d022e33d287fcadf6ab17b9b7a5b6da.svg";
export { ForwardRef as ReactComponent };